import React from 'react';
import { ShoppingBag, Radio, Gavel } from 'lucide-react';
import { features } from '../mock';

const iconMap = { brands: ShoppingBag, streams: Radio, auctions: Gavel };

const WaitlistFeatures = () => {
  return (
    <section id="features" className="relative py-24 md:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#39D353]/10 border border-[#39D353]/25 text-[11px] tracking-[0.15em] uppercase text-[#39D353] font-semibold">
              What you unlock
            </div>
            <h2 className="mt-5 text-[clamp(2rem,4.5vw,3.5rem)] leading-[1.05] font-bold tracking-tight max-w-2xl">
              A new home for wealth that&apos;s <span className="neon-text italic">on-chain</span>.
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md text-sm md:text-base leading-relaxed">
            Three ways to spend, discover and win — all inside one seamless, non-custodial app.
          </p>
        </div>

        <div id="how-it-works" className="grid md:grid-cols-3 gap-5 md:gap-6">
          {features.map((f, i) => {
            const Icon = iconMap[f.id];
            return (
              <article
                key={f.id}
                className="lift group relative overflow-hidden rounded-3xl border border-white/8 bg-[#0a0a0c] hover:border-[#39D353]/40 hover:shadow-[0_20px_60px_-25px_rgba(57,211,83,0.4)]"
              >
                {/* Image */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={f.image}
                    alt={f.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-[#0a0a0c]/40 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur-md border border-white/10">
                    <span className="h-1.5 w-1.5 rounded-full bg-[#39D353] neon-dot" />
                    <span className="text-[10px] tracking-wider uppercase text-white font-semibold">{f.tag}</span>
                  </div>
                  <div className="absolute top-4 right-4 h-10 w-10 rounded-full bg-[#39D353] text-black flex items-center justify-center shadow-[0_8px_30px_-6px_rgba(57,211,83,0.7)]">
                    <Icon size={18} />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 md:p-7 relative">
                  <div className="text-[11px] tracking-[0.2em] text-neutral-500 uppercase font-semibold">
                    0{i + 1}
                  </div>
                  <h3 className="mt-2 text-xl md:text-2xl font-bold text-white leading-tight">
                    {f.title}
                  </h3>
                  <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
                    {f.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WaitlistFeatures;
